// DELETE - file no longer in use
import ImageTools from './imageTools';
import utils from './utils';

const resizeImageForS3 = ({ file, path, size }) => {
  return new Promise((resolve, reject) => {
    if (file) {
      if (
        (path === 'signatures' ||
          path === 'logo' ||
          path === 'profile' ||
          path === 'testimonial') &&
        file.size > 2000000
      ) {
        reject(new Error(`The file ${file.name} is too large. You can upload images up to 2MB.`));
      } else if (path === 'covers' && file.size > 1500000) {
        reject(new Error(`The file ${file.name} is too large. You can upload images up to 1.5MB.`));
      } else if (path === 'attachments' && file.size > 3000000) {
        reject(
          new Error(
            `The attachment ${file.name} is too large. You can upload an attachment up to 3MB.`
          )
        );
      } else if (
        (path === 'media' || path === 'sections' || path === 'catalogs') &&
        file.size > 3000000
      ) {
        reject(new Error(`The file ${file.name} is too large. You can upload images up to 3MB.`));
      } else if (path === 'image' && file.size > 5000000) {
        reject(new Error(`The file ${file.name} is too large. You can upload images up to 5MB.`));
      } else if (path === 'externalproposals' && file.size > 10000000) {
        reject(
          new Error(`The file ${file.name} is too large. You can upload proposal up to 10MB.`)
        );
      }
    }

    // dont resize gif file
    if (path === 'media' || file.type === 'image/gif') return resolve(file);

    // Files that are already small gain almost nothing from resizing and only
    // lose sharpness — e.g. a 2000x500, ~171KB banner would be downsized to
    // ~950px wide and look blurry on high-DPI screens. Leave them untouched.
    // (mirrors SKIP_RESIZE_THRESHOLD in utils/image.js)
    const SKIP_RESIZE_THRESHOLD = 500 * 1024; // 500KB
    if (file.type && file.type.startsWith('image/') && file.size <= SKIP_RESIZE_THRESHOLD) {
      return resolve(file);
    }

    ImageTools.resize(file, size, (blob, didItResize) => {
      let fileToUpload = null;
      if (didItResize) {
        if (utils.isSafari()) {
          blob.name = file && file.name;
          fileToUpload = blob;
        } else {
          fileToUpload = new File([blob], (file && file.name) || 'somefile.png', {
            type: file?.type || 'image/png',
          });
        }
      } else {
        fileToUpload = file;
      }
      return resolve(fileToUpload);
    });
  });
};

export { resizeImageForS3 };
